import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, isEmpty as _isEmpty, } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { showAlertMessage } from "../../../../resusableComponents/common/formElements";

import { SingleDropzone, Select } from "../../../../resusableComponents/common/formElements";
import DownloadSampleFile from "../../../../resusableComponents/common/DownloadSampleFile";

import { saveCustomFields } from "../../../..//redux/services/campaignSetup";

import { resetCampaignSetupError, updateCampaignSetupDetails } from "../../../../redux/actions/campaignSetup";
import { updateLoadingState } from "../../../../redux/actions/application";

class UploadCustomFields extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fileUploaded: false,
      lastInsertedId: null,
      uploadedFileName: "",
      uploadedFileURL: "",
      disabled: false,
      isEditMode: false,
      uploadedCustomFields: [{ field_name: "", field_type: "textbox", is_required: false }],
      fieldTypes: [{ id: 1, name: "textbox" }],
      errors: {}
    };
  }

  componentDidMount() {
    const { source = "", summary, existingCustomFields = [], currentStep } = this.props;
    const { uploadedCustomFields } = this.state;
    const tmpAllUploadedCustomFields = (source !== "campaign_edit") ? _get(summary, `[${currentStep}].allUploadedCustomFields`, []) : existingCustomFields;

    if (!_isEmpty(tmpAllUploadedCustomFields)) {
      const mergedCustomFields = [...tmpAllUploadedCustomFields, ...uploadedCustomFields];
      const finalUploadedCustomFields = (mergedCustomFields || []).filter(item => item.field_name.trim() !== "");

      this.setState({ uploadedCustomFields: finalUploadedCustomFields });
    }
  }

  componentDidUpdate(prevProps, prevStates) {

    if (!_isEqual(prevProps.existingCustomFields, this.props.existingCustomFields)) {
      const { existingCustomFields } = this.props;

      this.setState({ uploadedCustomFields: existingCustomFields });
    }

    if (!_isEqual(prevProps.callCustomFieldSubmitAPI, this.props.callCustomFieldSubmitAPI) && (_get(this.props, "callCustomFieldSubmitAPI", false) === true)) {

      this._submitCustomFields();
    }
  }

  handleAddField = (name = "") => {
    this.setState((prevState) => ({
      uploadedCustomFields: [
        ...prevState.uploadedCustomFields,
        { field_name: (name || ""), field_type: "textbox", is_required: false }
      ]
    }));
  };

  handleFieldChange = (index, key, value) => {
    const updatedFields = [...this.state.uploadedCustomFields];
    updatedFields[index][key] = value;
    this.setState({ uploadedCustomFields: updatedFields });
  };

  handleRemoveField = (index) => {
    const updatedFields = [...this.state.uploadedCustomFields];
    updatedFields.splice(index, 1);
    this.setState({ uploadedCustomFields: updatedFields });
  };

  async _submitCustomFields() {
    const { source = "", goToNext, campaignId, selectedCampaignId, updateLoadingState, intl } = this.props;
    const { uploadedCustomFields } = this.state;
    const finalUploadedCustomFields = (uploadedCustomFields || []).filter(item => item.field_name.trim() !== "");

    if (source === "campaign_setup" && (_isEmpty(finalUploadedCustomFields || []))) {
      goToNext(finalUploadedCustomFields);
      return false;
    } else if (source === "campaign_edit" && (_isEmpty(finalUploadedCustomFields || []))) {
      showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "campaign_setup.custom_fields.title", defaultMessage: "custom fields" }) }
      ));
      return false;
    }

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      if (typeof saveCustomFields === "function") {

        const payload = {
          campaignId: (source === "campaign_edit") ? selectedCampaignId : campaignId,
          data: {
            json: finalUploadedCustomFields,
          },
        };

        const response = await saveCustomFields(payload);
        if ((response.flag || false) === true) {

          showAlertMessage(_get(response, "data.message", "Custom fields saved successfully."), "success");
          if (typeof goToNext === "function") { goToNext(finalUploadedCustomFields) };
        } else {
          showAlertMessage(_get(response, "message", "Something went wrong while saving custom fields."));
        }
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while saving custom fields."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  renderCustomFields = () => {
    const { uploadedCustomFields, fieldTypes } = this.state;

    return (
      <>
        <button
          type="button"
          className="btn btn-primary text-capitalize mb-3"
          onClick={() => this.handleAddField()}
        >
          <FormattedMessage id="campaign_setup.custom_fields.add_title" defaultMessage="Add Custom Field" />
        </button>

        <table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.name" defaultMessage="name" /></th>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.type" defaultMessage="type" /></th>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.is_required" defaultMessage="is required" /></th>
              <th className="text-capitalize"><FormattedMessage id="campaign_setup.custom_fields.column.action" defaultMessage="action" /></th>
            </tr>
          </thead>
          <tbody>
            {uploadedCustomFields.map((field, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={_get(field, "field_name", "")}
                    onChange={(e) => this.handleFieldChange(index, "field_name", _get(e, "target.value", ""))}
                  />
                </td>
                <td>
                  <Select
                    className="form-custom-select"
                    placeholder="Select Field Type"
                    options={fieldTypes}
                    value={fieldTypes.find(opt => opt.name === _get(field, "field_type" || ""))}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.name}
                    onChange={(selected) => this.handleFieldChange(index, "field_type", selected.name)}
                    isMulti={false}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value={(_get(field, "is_required", false) === true) ? 1 : 0}
                    checked={_get(field, "is_required", false)}
                    onChange={(e) => this.handleFieldChange(index, "is_required", e.target.checked)}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm text-capitalize"
                    onClick={() => this.handleRemoveField(index)}
                  >
                    <FormattedMessage id="campaign_setup.custom_fields.remove" defaultMessage="remove" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  };

  render = () => {
    const { source, campaignId, selectedCampaignId, clientId, allowedCustomFieldsFiles, allowedCustomFieldsFilesLabel } = this.props;
    const { uploadedFileName, uploadedFileURL, lastInsertedId } = this.state;

    return (
      <>
        <div className="row">
          <div className="col-lg-8">
            <div className="mb-3">
              <SingleDropzone
                acceptedFormat={allowedCustomFieldsFiles}
                allowedExtensions={allowedCustomFieldsFilesLabel}
                setState={(args) => this.setState(args)}
                addCustomField={(uploadedFields) => {
                  let allCustomFields = [];
                  (uploadedFields || []).forEach((field) => {
                    allCustomFields.push({
                      field_name: (field || ""),
                      field_type: "textbox",
                      is_required: false,
                    });
                  });
                  this.setState((prevState) => ({
                    uploadedCustomFields: (allCustomFields || [])
                  }));
                }}
                source="custom_fields"
                campaignId={(source === "campaign_edit") ? (selectedCampaignId || null) : (campaignId || null)}
                clientId={(clientId || null)}
                uploadedFileName={uploadedFileName}
                uploadedFileURL={uploadedFileURL}
                lastInsertedId={lastInsertedId}
                preserveSelectedFile={true}
                displayUploadedFiles={true}
                displayUploadedRemoveBtn={true}
              />
            </div>
            <p className="fw-bold text-grey-74 mb-3">
              <FormattedMessage id="campaign_setup.custom_fields.note" defaultMessage="Note: Please be aware that uploading a new file will replace the existing fields in the table list with those from the new file." />
            </p>
            <DownloadSampleFile source="custom_fields" />
          </div>
          <div className="mt-4">
            {this.renderCustomFields()}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  summary: _get(state, "campaignSetup.summary", {}),
  clientId: _get(state, "campaignSetup.summary.common.clientId", null),
  campaignId: _get(state, "campaignSetup.summary.common.campaignId", null),
  currentStep: _get(state, "campaignSetup.summary.common.currentStep", 1),
  allowedCustomFieldsFiles: _get(state, "application.constants.allowedCustomFieldsFiles", ""),
  allowedCustomFieldsFilesLabel: _get(state, "application.constants.allowedCustomFieldsFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
  resetCampaignSetupError: () => dispatch(resetCampaignSetupError()),
  updateCampaignSetupDetails: (data) => dispatch(updateCampaignSetupDetails(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UploadCustomFields));
